import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import {Property} from "../../property.model";

export class InvoicesDetail extends AbstractReport {

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

}

AccessorsMutatorsDecorator(
    'ident',
    'property_name',
    'email',
    'total',
    'balance',
    'property_id',
    'property',
    'status',
    'created_at',
    'attachment',
    'stat',
    'balance_sql',
    'id',
)(InvoicesDetail);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/admin-report/invoices-detail.model.js